import { apiCall } from '../api/ServerApi';
import { API_URL_PATHS } from '../consts/ApiUrlPaths';
import { findLatestDoneUrlSet } from '../helpers/UrlSetHelper';
import { IUrlSet } from '../interfaces/UrlSet';

const { URLSETS_URL_PATH } = API_URL_PATHS;

export type CreateUrlSetRequestBody = {
	propertyId: string;
	urls?: string[];
};

export async function createUrlSet(urlSetData: CreateUrlSetRequestBody): Promise<IUrlSet> {
	const body = { data: urlSetData };
	return apiCall('POST', URLSETS_URL_PATH, body);
}

export async function getUrlSetsUrls(urlSetId: string): Promise<string[]> {
	const url = `${URLSETS_URL_PATH}/${urlSetId}/urls`;
	return apiCall('GET', url);
}

export async function getUrlSet(urlSetId: string): Promise<IUrlSet> {
	const url = `${URLSETS_URL_PATH}/${urlSetId}?metadata=false`;
	return apiCall('GET', url);
}

async function getUrlSetsByProperty(propertyId: string): Promise<IUrlSet[]> {
	const url = `${URLSETS_URL_PATH}?propertyId=${propertyId}`;
	return apiCall('GET', url);
}

export async function getLatestSuccessfulUrlSet(propertyId: string): Promise<IUrlSet | null> {
	const urlSets = await getUrlSetsByProperty(propertyId);
	const latestValidUrlSet = findLatestDoneUrlSet(urlSets);
	if (!latestValidUrlSet) {
		return null;
	}
	return getUrlSet(latestValidUrlSet.id);
}
export async function deleteUrlSet(urlSetId: string): Promise<IUrlSet[]> {
	const url = `${URLSETS_URL_PATH}/${urlSetId}`;
	return apiCall('DELETE', url);
}
